import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('CURRENTUSER_ABO').plugin(axiosPlugin);

let fetchCurrentUserAboAction = redux.fetchActionGet();

export const fetchCurrentUserAbo = (query = {}) => fetchCurrentUserAboAction(`/users/me/abo`);
export const resetCurrentUserAbo = () => redux.actions.reset();

export const currentUserAbo = redux.reducer();